import React, {Component} from "react";
import 'antd/dist/antd.css';
import { message, Button, Row, Col, Radio } from 'antd';
import { Redirect } from 'react-router-dom';
const RadioGroup = Radio.Group;

let gender = '';

// Module for RandomSearch
// NOTE: it searches for random gender, ignore variable names
// suggestion: this below arrays should be part of a database, (firebase?) 
let ClothArrayTop = ["shirt", "tshirt", "top", "jacket"];
let ClothArrayBottom = ["jeans", "pant", "shorts"];
let ClothArrayColor = ["red", "blue", "green", "yellow", "white", "brown"];
let ClothArrayType = ["dress", "suit", "casual", "outfit", "look"];

const btnStyle =  {
  height: '50px',
  width: '60%',
}


export default class RPS extends Component {

  RPS (e)
  { e.preventDefault();
    var Color = ClothArrayColor[Math.floor(Math.random() * ClothArrayColor.length)];
    var Top = ClothArrayTop[Math.floor(Math.random() *ClothArrayTop.length)];
    var Bottom = ClothArrayBottom[Math.floor(Math.random() * ClothArrayBottom.length)];
    var Cloth = ClothArrayType[Math.floor(Math.random() * ClothArrayType.length)];
  
    if(gender === '')
    {
      message.error('Please select a gender!');
    }
    else {
    var redirectWindow = window.open("https://in.pinterest.com/search/pins/?q= " + Top + " " + Bottom + " " + Color + " " + Cloth + " " + gender,"_blank");
    <Redirect to={redirectWindow} />
    }
  };

  onChange(e){
    e.preventDefault();
    console.log(e.target.value);
    gender= e.target.value;
  }

  render() {
    return(<div>
      <Row type="flex" justify="center" style={{ paddingBottom: '5px'}}>
        <h4>No time or being super lazy? Let me help you with some <em>inspiration</em>! Choose gender and press the button..</h4>
    </Row>
      <Row type="flex" justify="center" gutter={16}>
        <RadioGroup onChange={this.onChange} defaultValue="men" size="large" style={{ paddingBottom: '10px' }}>
        <Col span={12}>
          <Radio value="man">
            Boy
          </Radio>
        </Col>
        <Col span={12}>
          <Radio value="woman">
            Girl
          </Radio>
        </Col>
      </RadioGroup>
      </Row>
      <Row type="flex" justify="center">
        <Button size="large" style={btnStyle} type="primary" onClick={this.RPS}>Generate Random Outfit</Button>
      </Row>
      </div>);
  }
}


// WEBPACK FOOTER //
// ./src/rndmpnsrch.js